import { useState, useRef } from "react";
import { encryptStorage } from "../../../constants/EncryptStorage";

/**
 * Custom hook to manage all document-related state
 */
export const useDocumentState = () => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const loggedInUnitName = encryptStorage.getItem("loggedInUnitName");

  // Folder and navigation state
  const [folderUnitId, setFolderUnitId] = useState(loggedInUnitId);
  const [unitFolderUnitId, setUnitFolderUnitId] = useState(0);
  const [folderId, setFolderId] = useState(0);
  const [foldersBreadCrumbs, setFoldersBreadCrumbs] = useState([]);
  const [folderParentUnitIds, setFolderParentUnitIds] = useState([]);
  const [hierarchyDisable, setHierarchyDisable] = useState(false);

  // Tab and view state
  const [activeTab, setActiveTab] = useState("otherFiles");
  const [loading, setLoading] = useState(false);

  // Document and folder data
  const [documents, setDocuments] = useState([]);
  const [unitFolders, setUnitFolders] = useState([]);
  const [documentTagsList, setDocumentTagsList] = useState([]);

  // Modal states
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const [uploadFolderModal, setUploadFolderModal] = useState(false);
  const [editFolderModal, setEditFolderModal] = useState(false);
  const [editFileModal, setEditFileModal] = useState(false);
  const [editValue, setEditValue] = useState();
  const [showUploadOpions, setShowUploadOptions] = useState(false);

  // Row selection and hover state
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [unitSelectedRowIndex, setUnitSelectedRowIndex] = useState(null);
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [unitHoveredRowIndex, setUnitHoveredRowIndex] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const [detailBox, setDetailBox] = useState(false);

  // Multiple selection state
  const [selectedDocumentsForDelete, setSelectedDocumentsForDelete] = useState([]);
  const [selectedByDragging, setSelectedByDragging] = useState(false);
  const [selectionBox, setSelectionBox] = useState({ start: null, current: null });
  const [dragTimeout, setDragTimeout] = useState(null);

  // Search and filter state
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  const [resultFromSearch, setResultFromSearch] = useState(false);

  // File operation state
  const [droppedFile, setDroppedFile] = useState(null);
  const [droppedFolder, setDroppedFolder] = useState(null);
  const [error, setError] = useState(null);
  const [deletionInProgress, setDeletionInProgress] = useState(false);
  const [uploadInProgress, setUploadInProgress] = useState(false);
  const [isCalled, setIsCalled] = useState(false);
  const [isDownloading, setIsDownloading] = useState([]);

  // Tooltip state
  const [tooltipOpen, setTooltipOpen] = useState({});
  const [deleteMultipleButtonTooltipOpen, setDeleteMultipleButtonTooltipOpen] = useState(false);

  // Refs
  const searchBoxRef = useRef(null);
  const tableRef = useRef(null);
  const overlayRef = useRef(null);
  const skipFolderIdUpdate1 = useRef(false);

  return {
    // Navigation
    folderUnitId,
    setFolderUnitId,
    unitFolderUnitId,
    setUnitFolderUnitId,
    folderId,
    setFolderId,
    foldersBreadCrumbs,
    setFoldersBreadCrumbs,
    folderParentUnitIds,
    setFolderParentUnitIds,
    hierarchyDisable,
    setHierarchyDisable,

    // Tabs and view
    activeTab,
    setActiveTab,
    loading,
    setLoading,

    // Data
    documents,
    setDocuments,
    unitFolders,
    setUnitFolders,
    documentTagsList,
    setDocumentTagsList,

    // Modals
    newFolderModal,
    setNewFolderModal,
    uploadFileModal,
    setUploadFileModal,
    uploadFolderModal,
    setUploadFolderModal,
    editFolderModal,
    setEditFolderModal,
    editFileModal,
    setEditFileModal,
    editValue,
    setEditValue,
    showUploadOpions,
    setShowUploadOptions,

    // Selection
    selectedRowIndex,
    setSelectedRowIndex,
    unitSelectedRowIndex,
    setUnitSelectedRowIndex,
    hoveredRowIndex,
    setHoveredRowIndex,
    unitHoveredRowIndex,
    setUnitHoveredRowIndex,
    selectedFile,
    setSelectedFile,
    detailBox,
    setDetailBox,
    selectedDocumentsForDelete,
    setSelectedDocumentsForDelete,
    selectedByDragging,
    setSelectedByDragging,
    selectionBox,
    setSelectionBox,
    dragTimeout,
    setDragTimeout,

    // Search
    searchTerm,
    setSearchTerm,
    selectedTags,
    setSelectedTags,
    clearSearch,
    setClearSearch,
    resultFromSearch,
    setResultFromSearch,

    // File operations
    droppedFile,
    setDroppedFile,
    droppedFolder,
    setDroppedFolder,
    error,
    setError,
    deletionInProgress,
    setDeletionInProgress,
    uploadInProgress,
    setUploadInProgress,
    isCalled,
    setIsCalled,
    isDownloading,
    setIsDownloading,

    // Tooltips
    tooltipOpen,
    setTooltipOpen,
    deleteMultipleButtonTooltipOpen,
    setDeleteMultipleButtonTooltipOpen,

    // Refs
    searchBoxRef,
    tableRef,
    overlayRef,
    skipFolderIdUpdate1,

    // Constants
    loggedInUnitId,
    loggedInUnitName,
  };
};
